import type { BidPurchaseOption } from './Payment';

export interface SubmittableCartItem {
  encryptedId: string;
  variant: SubmittableVariant;
  roundTripBundle?: boolean;
}

export interface SubmittableVariant {
  encryptedId: string; // encrypted variant id contains flight productId + upgradeType + travelDate
  cashPurchaseOption?: SubmittablePurchaseOption;
  pointsPurchaseOption?: SubmittablePurchaseOption;
  fromCabin: string;
  meta?: NFFVariantMeta;
}

export interface NFFVariantMeta {
  assignedSeats: NFFSeat[];
  blockedSeats: NFFSeat[];
  isFallback?: boolean;
}

export interface NFFSeat {
  seatNumber: string;
  passenger: NFFSeatPassenger | null;
}

export interface NFFSeatPassenger {
  firstName: string;
  lastName: string;
}

export type SubmittablePurchaseOption = BidPurchaseOption & {
  paymentProfileId: string;
  encodedAffiliateCustomerId?: string;
  affiliateCode?: string;
};

export interface SubmittableCart {
  currencyCode: string;
  languageCode: string;
  encryptedExperienceContext: string;
  billingEmail: string;
  useFcc: boolean;
  requestId: string;
  termsAndConditionsAccepted?: boolean;
  items: SubmittableCartItem[];
  additionalChannelSources: string[];
  submissionOptions?: Record<string, unknown>;
}

export interface SubmitExperienceCartResponse {
  eOfferIds: string[];
  eRetriableOfferIds: [];
  errorMessages: string[];
  success: boolean;
  offerStates: OfferState[];
}

export interface OfferState {
  eOfferId: string;
  reason: TicketingReasonCodeString;
  retryable: boolean;
  status: string;
}

export type TicketingReasonCodeString = TicketingReasonCode | string;
/**
 * @see: https://bitbucket.org/plusgrade/ws-commons-datatypes/src/master/src/main/java/com/plusgrade/commons/value/TicketingReasonCode.java
 */
export enum TicketingReasonCode {
  REBOOK_AND_REBOARD_FAILED = 'REBOOK_AND_REBOARD_FAILED',
  REBOOKED_THEN_REBOARD_FAILED = 'REBOOKED_THEN_REBOARD_FAILED',
  UNKNOWN = 'UNKNOWN',
  OTHER = 'OTHER',
}
